
/**
 * @public
 */
export const EMPTY_ARRAY: ReadonlyArray<any> = []; // tslint:disable-line:no-any

/**
 * @public
 */
export function add<TValue>(entries: ReadonlyArray<TValue>, entry: TValue): ReadonlyArray<TValue> {
  const index = entries.indexOf(entry);

  return index > -1 ?
    entries :
    [...entries, entry];
}

/**
 * @public
 */
export function remove<TValue>(entries: ReadonlyArray<TValue>, entry: TValue): ReadonlyArray<TValue> {
  return removeOrDelete(entries, entry) || [];
}

/**
 * @public
 */
export function addOrCreate<TValue>(entries: ReadonlyArray<TValue> | undefined, entry: TValue): ReadonlyArray<TValue> {
  return entries ?
    add(entries, entry) :
    [entry];
}

/**
 * @public
 */
export function removeOrDelete<TValue>(entries: ReadonlyArray<TValue>, entry: TValue): ReadonlyArray<TValue> | undefined {
  const index = entries.indexOf(entry);

  return index > -1 ?
    entries.length === 1 ?
      undefined :
      [...entries.slice(0, index), ...entries.slice(index + 1)] :
    entries;
}

/**
 * @public
 */
export function concat<TValue>(base: ReadonlyArray<TValue>, extension: ReadonlyArray<TValue>): ReadonlyArray<TValue> {
  if (base.length > 0 && extension.length > 0) {
    return [...base, ...extension];
  } else if (base.length > 0) {
    return base;
  } else if (extension.length > 0) {
    return extension;
  }

  return EMPTY_ARRAY;
}

/**
 * @public
 */
export function findMatch<TValue>(entries: TValue[], match: (value: TValue) => boolean): {
  value: TValue;
  index: number;
} | undefined {
  for (let i = 0; i < entries.length; i++) {
    const value = entries[i];

    if (match(value)) {
      return {
        value,
        index: i
      };
    }
  }
}
